import tw from 'twin.macro';

export const Container = tw.div``;
export const Spacer = tw.div`w-full h-14`;
export const Title = tw.div`font-size[2rem] font-bold text-align[center] mb-5`;
export const Content = tw.div`px-4`;
export const Card = tw.div`w-full font-medium px-3 py-4 bg-white rounded-md box-shadow[0 2px 6px 1px rgba(0, 0, 0, 0.1)] mb-2
hover:background-color[#b7edf7] transition[all 0.3s ease-in-out]`;
